import { createSlice } from '@reduxjs/toolkit';

const lobbySlice = createSlice({
  name: 'lobby',
  initialState: {
    players: [],
    incomingChallenge: null,   // { from, name, gameType }
    currentRoom: null,         // full room object from server
    view: 'lobby',             // 'lobby' | 'tictactoe' | 'battleship'
    challengeDeclined: false,
    pendingChallenge: null,    // targetId we challenged
    opponentLeft: false,
    opponentDisconnected: false,
    connectionLost: false,     // OUR socket is disconnected
    challengeError: null,      // toast message when a challenge can't proceed
    rematchMine: false,        // I asked for a rematch, waiting for opponent
    rematchOpponent: false,    // opponent asked for a rematch
  },
  reducers: {
    setPlayers(state, action) {
      state.players = action.payload;
    },
    setIncomingChallenge(state, action) {
      state.incomingChallenge = action.payload;
    },
    clearChallenge(state) {
      state.incomingChallenge = null;
    },
    setCurrentRoom(state, action) {
      state.currentRoom = action.payload;
    },
    setView(state, action) {
      state.view = action.payload;
    },
    setChallengeDeclined(state, action) {
      state.challengeDeclined = action.payload;
      state.pendingChallenge = null;
    },
    setPendingChallenge(state, action) {
      state.pendingChallenge = action.payload;
    },
    setOpponentLeft(state, action) {
      state.opponentLeft = action.payload;
      state.opponentDisconnected = false;
    },
    setOpponentDisconnected(state, action) {
      state.opponentDisconnected = action.payload;
    },
    setConnectionLost(state, action) {
      state.connectionLost = action.payload;
    },
    setChallengeError(state, action) {
      state.challengeError = action.payload;
      if (action.payload) state.pendingChallenge = null;
    },
    challengeCancelled(state, action) {
      // The challenger withdrew — close the modal if it's theirs
      if (state.incomingChallenge?.from === action.payload) {
        state.incomingChallenge = null;
      }
    },
    setRematchMine(state, action) {
      state.rematchMine = action.payload;
    },
    setRematchOpponent(state, action) {
      state.rematchOpponent = action.payload;
    },
    resetRematch(state) {
      state.rematchMine = false;
      state.rematchOpponent = false;
    },
    resetGame(state) {
      state.currentRoom = null;
      state.view = 'lobby';
      state.opponentLeft = false;
      state.opponentDisconnected = false;
      state.pendingChallenge = null;
      state.rematchMine = false;
      state.rematchOpponent = false;
    },
  },
});

export const {
  setPlayers, setIncomingChallenge, clearChallenge,
  setCurrentRoom, setView, setChallengeDeclined,
  setPendingChallenge, setOpponentLeft, setOpponentDisconnected,
  setConnectionLost, setChallengeError, challengeCancelled,
  setRematchMine, setRematchOpponent, resetRematch, resetGame,
} = lobbySlice.actions;
export default lobbySlice.reducer;
